import React from "react";
import NcImage from "shared/NcImage/NcImage";
import NcLink from "shared/NcLink/NcLink";
import useResponsive from "hooks/useResponsive";
import { useAppSelector } from "store/hooks";


const HomePageLightPollution = () => {
  const lightPollution = useAppSelector((state) => state.homePage.data?.lightPollutionBanner);
  const {smaller}=useResponsive();
  return (
    <div className="nc-HomePageLightPollution relative w-full overflow-hidden shadow-lg">
      <NcLink to={`/darksky-products`}>
        <NcImage
          containerClassName="w-full h-auto relative"
          src={smaller.sm ? lightPollution?.mobileBannersURL:lightPollution?.bannersURL}
          className="object-cover object-center w-full h-full"
          alt={`Let's Beat Light Pollution Together! (DarkSky Approved)`}
        />
      </NcLink>
    </div>
  );
};

export default HomePageLightPollution;
